import React, { useState } from 'react';
import { map, filter, get, findIndex, slice, size, difference, compact, isEmpty } from 'lodash';
import { func, object, number, array } from 'prop-types';
import { Button, Row, Column, Icon } from '../../../../common';
import { genUUID } from '../../../../../utils/misc';
import Condition from './Condition';

const ConditionalQuestion = ({ values, question, updateQuestions, typeQuestion, satisfactionOptions }) => {
    const conditions = get(question, 'conditions') || [];
    const [isHoverButton, setIsHoverButton] = useState(false);

    const questionsFormatted = map(get(values, 'questions'), ({ idQuestion, question }) => {
        return { label: question, value: idQuestion };
    });

    const questionOptionsFormatted = map(get(question, 'options'), ({ idOption, description }) => {
        return { label: description, value: idOption };
    });

    const satisfactionOptionsFormatted = map(satisfactionOptions, ({ translate, value }) => {
        return { label: translate, value };
    });

    const addCondition = () => {
        const newCondition = [{ idCondition: genUUID() }];
        updateQuestions('conditions', [...conditions, ...newCondition]);
    };

    const removeCondition = (condition) => {
        const newConditions = filter(conditions, ({ idCondition }) => idCondition !== get(condition, 'idCondition'));
        updateQuestions('conditions', newConditions);
    };

    const getQuestionsFromCurrentPosition = () => {
        const indexFound = findIndex(questionsFormatted, ({ value }) => value === get(question, 'idQuestion'));
        return slice(questionsFormatted, indexFound + 1, size(questionsFormatted));
    };

    const validateAddCondition = () => {
        const idNextQuestions = compact(map(conditions, 'idNextQuestion'));
        const options = map(getQuestionsFromCurrentPosition(), 'value');
        const remainingOptions = difference(options, idNextQuestions);
        const maxConditions = size(getQuestionsFromCurrentPosition());
        return isEmpty(remainingOptions) || !(size(conditions) < maxConditions);
    };

    const getOptionCSAT = () =>
        size(questionOptionsFormatted) > 0 ? questionOptionsFormatted : satisfactionOptionsFormatted

    const cleanConditions = () => {
        const questions = getQuestionsFromCurrentPosition()

        // const newConditions = filter(conditions, ({ idNextQuestion }) => {
        //     return some(questions, { value: idNextQuestion })
        // })

        return conditions
    }

    return <Column gap={10} mT={15}>
        {map(cleanConditions(), (condition) => {
            return <Condition
                condition={condition}
                removeCondition={() => removeCondition(condition)}
                questions={questionsFormatted}
                options={getOptionCSAT()}
                question={question}
                conditions={conditions}
                updateQuestions={updateQuestions}
                typeQuestion={typeQuestion}
                questionsFromCurrentPosition={getQuestionsFromCurrentPosition()}
            />;
        })}
        {<Row justify='flex-end' align='center'>
            <Button
                width={240}
                onClick={addCondition}
                disabled={validateAddCondition()}
                secondaryQuestion
                onMouseEnter={() => setIsHoverButton(true)}
                onMouseLeave={() => setIsHoverButton(false)}
            >
                <Row justify='flex-end' align='center' gap={7}>
                    <Icon name='new-plus' color={!isHoverButton ? '#a4c735' : '#ffffff'} size={18} />
                    Agregar condición
                </Row>
            </Button>
        </Row>}
    </Column>;
};

ConditionalQuestion.propTypes = {
    values: object,
    question: object,
    updateQuestions: func,
    typeQuestion: number,
    satisfactionOptions: array
};

export default ConditionalQuestion;
